import React from 'react'
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'
import cx from 'classnames'

import './ui.scss'

const Drawer = ({
  className,
  children,
  open = false,
  anchor = 'right',
  onClose = () => {},
  onOpen = () => {},
  ...props
}) => {
  const classes = cx(className, 'm-drawer', {
    'm-drawer--shown': open,
    'm-drawer--hidden': !open,
  })

  return (
    <SwipeableDrawer
      open={open}
      anchor={anchor}
      onClose={onClose}
      onOpen={onOpen}
      variant={'persistent'}
      className={classes}
    >
      { children }
    </SwipeableDrawer>
  )
}

export default Drawer
